import styled from "styled-components";
import { buttonStyles } from "../Buttons.elements";
import theme from "common/theme";

export const SortButtonContainer = styled.button`
    ${buttonStyles};
    color: ${theme.colors.main};
    border-radius: 0;
    text-align: left;
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr;
    grid-column-gap: .5em;
    .label {
        grid-row-start: span 2;
        grid-column: 1;
    }

    &.asc .up { opacity: 1!important; }
    &.desc .down { opacity: 1!important; }
   
    &:not(.has-icons) {
        .up, .down {
            width: .5em;
            height: .5em;
            opacity: .2;
        }
        .up { 
            transform: rotate(180deg); 
            grid-row: 1;
            grid-column: 2;
        }
        .down {
            grid-row: 2;
            grid-column: 2;
        }
    }
 &:hover { .icon { opacity: 1; }}
    
`